import styled from 'styled-components';

export const Card = styled.section`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 18px 20px;
`;

export const CardHead = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 14px;
  h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #262626;
  }
  span {
    font-size: 13px;
    color: #8c8c8c;
  }
`;
